<div class="dform-error-wrap">
  <img class="dform-error-image" src="assets/images/logo_mbbank.png">
  <div class="dform-error-code">{{code}}</div>
  <div class="dform-error-title" *ngIf="title">{{title | translate}}</div>
  <div fxLayout="row" fxLayoutAlign="center center">
    <button class="btn btn-error btn-lg" (click)="gotoLogin()">
      {{ 'btn.login' | translate }}
    </button>
    <button class="btn btn-primary mrl-4 btn-lg" (click)="gotoHome()">
      {{button | translate}}
    </button>
  </div>
</div>
